import { useState } from "react";
import Editor from "react-simple-wysiwyg";
import { Typography } from "@mui/material";

interface EmailEditorProps {
  template: string;
  setTemplate: React.Dispatch<React.SetStateAction<string>>;
  label?: string;
}

const EmailEditor: React.FC<EmailEditorProps> = ({ template, setTemplate, label }) => {
  const onChange = (e: any) => {
    setTemplate(e.target.value);
  };

  return (
    <div>
      {label && (
        <Typography variant="subtitle1" fontWeight={500} gutterBottom>
          {label}
        </Typography>
      )}
      <Editor value={template} onChange={onChange} />
    </div>
  );
};

export default EmailEditor;
